import React from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import {BASE} from '../api/api'
import Axios from 'axios'
import ReactHtmlParser from 'react-html-parser';

class Lamha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lamha: ''
        }
    }
    //  printTest2() {
    //   printJS('http://devifdb-be.tridz.in/print/view/pdf/publications_view/page_1?view_args[]=43054,40409,40325')

    // }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    fn() {
        let apis = [
            { info: { title: 'select some title' } },
            { info: { title: 'some title 2' } },
            { info: { title: 'some title 3' } }
        ];

        let toSearch = 'select'; //Will check if title have text 'search'

        let result = apis.filter(o => o.info.title.includes(toSearch));

        console.log(apis, result, 'filter');
    }

    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }


    componentWillMount() {
        if (localStorage.getItem('token'))
            this.checkexpiry()

        Axios(BASE + 'jsonapi/node/page?filter[drupal_internal__nid]=71', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.setState({
                    lamhatitle: data.data.data[0].attributes.title,
                    lamha: data.data.data[0].attributes.body.processed
                })
                this.topFunction()

            })
            .catch((err) => {
                console.log('not found')
            })
    }
    render() {
        return (
            <div className='biopage'>
                <Header />
                <div className="page-people" >
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container gloss_container">
                                <div>
                                    <h1 className="page-header">{'Lamha'}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content listing">
                        <div className="container ">
                            <div className="row">
                                <div className="region region-content">
                                    <div className="listings">
                                        <h5 style={{ color: 'grey', marginLeft: '7px' }}>Under Construction</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Footer />
                </div>
            </div>
        )
    }
}
export default Lamha